(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    document.querySelectorAll("[data-product-tabs]").forEach(function (tabs) {
      var buttons = tabs.querySelectorAll("[data-product-tab]");
      var panels = tabs.querySelectorAll("[data-product-panel]");
      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          var target = button.getAttribute("data-product-tab");
          buttons.forEach(function (b) { b.classList.toggle("active", b === button); });
          panels.forEach(function (panel) {
            panel.classList.toggle("active", panel.getAttribute("data-product-panel") === target);
          });
        });
      });
    });

    document.querySelectorAll("[data-nr-video]").forEach(function (wrap) {
      var btn = wrap.querySelector("[data-nr-play]");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var id = wrap.getAttribute("data-nr-video");
        wrap.innerHTML = '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" title="Neverrift Game Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      });
    });

    document.querySelectorAll("[data-nr-add]").forEach(function (button) {
      button.addEventListener("click", async function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (button.disabled) return;
        var original = button.textContent;
        button.disabled = true;
        button.textContent = "Adding...";
        try {
          var formData = new FormData();
          formData.append("id", button.dataset.variantId);
          formData.append("quantity", "1");
          var response = await fetch("/cart/add.js", { method: "POST", body: formData });
          var data = await response.json();
          if (!response.ok || data.status === 422) throw new Error(data.description || data.message || "Add failed");
          button.textContent = "Added!";
          if (window.cartDrawer) {
            await window.cartDrawer.refreshCart();
            window.cartDrawer.open();
          }
        } catch (err) {
          button.textContent = "Error";
        }
        setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 1600);
      });
    });
  });
})();
